module.exports = __webpack_public_path__ + "img/flower_pattern.770b702b.jpg";